import { render, staticRenderFns } from "./LayoutBuilder.vue?vue&type=template&id=71a5867c&scoped=true&"
import script from "./LayoutBuilder.vue?vue&type=script&lang=js&"
export * from "./LayoutBuilder.vue?vue&type=script&lang=js&"
import style0 from "./LayoutBuilder.vue?vue&type=style&index=0&id=71a5867c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a5867c",
  null
  
)

export default component.exports